import React from 'react'

const FormError = ({Value}) => {
  return (
    <div className={Value === ''? 'forms_error forms_hidden' : 'forms_error forms_visible'}>
      <p><b>Exception: </b>{Value}</p>
    </div>
  )
}

export default FormError
